export { default as CmdbObjectPicker } from './cmdb-object-picker';
